import { scrollRegionClass } from '../../ScrollRegion'

/**
 * 灵动岛表面类名（几何 / 材质；与 Toast、chrome-bar 同系 token）。
 * 业务语义色在页面或业务组件内追加。
 */

/** 宿主外层：全宽 flex 居中（z-index 500，低于 Toast 520，高于顶栏 40） */
export function themeDynamicIslandAnchorClass(): string {
  return [
    'pointer-events-none fixed inset-x-0 top-[max(0.5rem,env(safe-area-inset-top))] z-[500]',
    'flex justify-center px-3',
  ].join(' ')
}

export function themeDynamicIslandFloaterClass(): string {
  return 'pointer-events-auto relative z-[1] w-max max-w-[min(calc(100vw-1.5rem),26rem)]'
}

/**
 * 灵动岛壳层：对齐 {@link .glyphicai-dynamic-island} 与 chrome 菜单实色。
 * @param angular 直角主题（pixel / geek）
 * @param expanded 展开态（圆角与内边距由 CSS transition 过渡）
 * @param glass 玻璃主题时叠加 glass-chrome
 */
export function themeDynamicIslandShellClass(angular: boolean, expanded: boolean, glass: boolean): string {
  return [
    'glyphicai-dynamic-island',
    'pointer-events-auto antialiased',
    'border border-line bg-[var(--menu-solid)] text-ink shadow-card',
    glass ? 'glass-chrome glass-chrome-solid' : '',
    expanded ? 'glyphicai-dynamic-island--expanded' : 'glyphicai-dynamic-island--compact',
    angular ? 'glyphicai-dynamic-island--angular rounded-none border-2' : '',
  ]
    .filter(Boolean)
    .join(' ')
}

export function themeDynamicIslandCompactTriggerClass(): string {
  return [
    'flex w-full min-w-0 items-center gap-2 text-left outline-none',
    'focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--menu-solid)]',
  ].join(' ')
}

export function themeDynamicIslandExpandedBodyClass(): string {
  return 'flex w-full flex-col gap-2.5'
}

export function themeDynamicIslandActionRowClass(): string {
  return 'flex flex-wrap items-center justify-end gap-1.5'
}

/** 岛上 Chrome 工具栏钮：在 {@link chromeToolbarButtonClass} 基础上略缩小（次要操作） */
export function themeDynamicIslandToolbarButtonClass(): string {
  return '!px-2.5 !py-1 !text-[10px] !leading-none'
}

/** 展开态主操作钮（详情、关闭等）：比 toolbar 钮更大，便于点按 */
export function themeDynamicIslandActionButtonClass(): string {
  return '!min-h-[2.125rem] !px-3.5 !py-1.5 !text-xs !font-semibold !leading-snug'
}

/** 灵动岛队列列表滚动区：复用全站 {@link scrollRegionClass} */
export function themeDynamicIslandQueueScrollClass(compact: boolean): string {
  return [
    scrollRegionClass('y'),
    compact ? 'max-h-[min(28vh,12rem)]' : 'max-h-[min(52vh,22rem)]',
    'overflow-x-hidden',
  ].join(' ')
}
